import React from "react";
import TicketOverviewDashboard from "./TicketOverviewDashboard";
//import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import ErrorBoundary from "../../../ErrorBoundary";

const TicketOverview = ({ dashboardData }) => {
  return (
    <div className="pb-15">
      {dashboardData?.section ? (
        dashboardData?.section[0]?.widgets?.map((e, i) => {
          return (
            <ErrorBoundary>
              <TicketOverviewDashboard data={e} widget_index={i} />
            </ErrorBoundary>
          );
        })
      ) : (
        <div
          className="loader text-center w-100"
          style={{ height: "calc(100vh - 15.2rem)" }}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketOverview;
